import { createAction } from 'redux-actions';

import * as types from './types';

export const postAction = createAction(types.POST_ACTION);
export const getActions = createAction(types.GET_ACTIONS);
export const deleteAction = createAction(types.DELETE_ACTION);
export const getActionsSuccess = createAction(types.GET_ACTIONS_SUCCESS);
